import * as React from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import { initializeAmplitude } from './utils/amplitude';

// Initialize Amplitude before rendering the app
/* istanbul ignore next */
initializeAmplitude();

const container = document.getElementById('root');
const root = createRoot(container!);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
